var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 14.1012 14.1012 0 31.5 0C48.8988 0 63 14.1012 63 31.5C63 48.8988 48.8988 63 31.5 63C14.1012 63 0 48.8988 0 31.5ZM45.7488 26.0613C47.09 24.7201 47.09 22.5299 45.7488 21.1887C44.4076 19.8475 42.2174 19.8475 40.8762 21.1887L27.5625 34.5023L22.1238 29.0637C20.7826 27.7225 18.5924 27.7225 17.2512 29.0637C15.91 30.4049 15.91 32.5951 17.2512 33.9363L25.1262 41.8113C26.4674 43.1525 28.6576 43.1525 29.9988 41.8113L45.7488 26.0613Z",
    fill: "#7BDDBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.0fc8865b4df5eedee355205a91872f01.svg";
export { ForwardRef as ReactComponent };